import { createContext } from 'react';

interface RowContextType {
  /** The unique identifier of the row item. */
  itemId?: string;
  /** Indicates whether the row is selected. */
  selected?: boolean;
  /** Indicates whether the row is disabled. */
  disabled?: boolean;
  /**
   * A callback function that is called when the row is interacted with.
   * The function receives the `event` object as an argument.
   */
  onInteraction?: (event: React.MouseEvent) => void;
}

export const RowContext = createContext<RowContextType>({});
